import { colors } from '@salonomy/design-tokens';
import type { ChairAccent } from './DiaryGrid.js';

/**
 * Per-chair colour treatments, mirroring the diary design's visual variety (cobalt / ink / slate /
 * cobalt-light down the columns). The primary accent of each chair is a brand token (no hardcoded
 * brand hex); the soft tints / rgba shadows are explicit derived colours rather than `color-mix` so
 * the diary renders identically on a 5-year-old iPad's Safari (brief WS2 performance/device target).
 */
export const CHAIR_ACCENTS: ChairAccent[] = [
  {
    accent: colors.cobalt,
    soft: '#EAEDFB',
    queue: 'rgba(58,85,217,0.08)',
    shadow: 'rgba(58,85,217,0.3)',
  },
  {
    accent: colors.ink,
    soft: '#F0F1F5',
    queue: 'rgba(22,29,51,0.06)',
    shadow: 'rgba(22,29,51,0.25)',
  },
  {
    accent: '#7785A8',
    soft: '#EFF1F5',
    queue: 'rgba(119,133,168,0.1)',
    shadow: 'rgba(119,133,168,0.25)',
  },
  {
    accent: colors.cobaltLight,
    soft: '#EEF2FF',
    queue: 'rgba(123,147,255,0.12)',
    shadow: 'rgba(123,147,255,0.3)',
  },
];

export function chairAccent(index: number): ChairAccent {
  return CHAIR_ACCENTS[index % CHAIR_ACCENTS.length]!;
}
